export const FOLLOWER_LIST_ATTEMPT = "FOLLOWER_LIST_ATTEMPT";
export const FOLLOWER_LIST_SUCCESS = "FOLLOWER_LIST_SUCCESS";
export const FOLLOWER_LIST_FAILED = "FOLLOWER_LIST_FAILED";
////////////////////////////////////
export const FOLLOWER_UPDATE_SUCCESS = "FOLLOWER_UPDATE_SUCCESS";
export const FOLLOWER_UPDATE_FAILED = "FOLLOWER_UPDATE_FAILED";
export const LOGOUT = "LOGOUT";

